import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * Before any route is loaded, check if the user has completed the verification process.
 * Any route that requires authentication should placed inside _authenticated folder.
 */

export const Route = createFileRoute('/connect/_authenticated')({
  beforeLoad: async ({ context }) => {
    const { verificationCompleted } = context.authentication;

    if (!verificationCompleted) {
      throw redirect({
        to: '/connect/login/',
        search: prev => prev,
      });
    }
  },
});
